const auth_organizations = [
    {
        "id": 204,
        "createdAt": 1700704133829,
        "createdBy": 1,
        "updatedAt": 1700704133829,
        "updatedBy": 1,
        "pid": 0,
        "code": "kh",
        "enabled": true,
        "details": [
            {
                "locale": "en-US",
                "organizationId": 204,
                "name": "Customer",
                "description": null
            },
            {
                "locale": "zh-CN",
                "organizationId": 204,
                "name": "客户",
                "description": null
            }
        ],
        "children": []
    },
  {
      "id": 205,
      "createdAt": 1700704133829,
      "createdBy": 1,
      "updatedAt": 1704370835586,
      "updatedBy": 8888,
      "pid": 1,
      "code": "service",
      "enabled": true,
      "details": [
          {
              "locale": "en-US",
              "organizationId": 205,
              "name": "Service",
              "description": null
          },
          {
              "locale": "zh-CN",
              "organizationId": 205,
              "name": "本地售后服务",
              "description": null
          }
      ],
      "children": [
          {
              "id": 214,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650379545,
              "updatedBy": 8888,
              "pid": 205,
              "code": "sq",
              "enabled": true,
              "details": [
                  {
                      "locale": "en-US",
                      "organizationId": 214,
                      "name": "师桥鸣鹤掌起",
                      "description": null
                  },
                  {
                      "locale": "zh-CN",
                      "organizationId": 214,
                      "name": "赵魏锋",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 206,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650258895,
              "updatedBy": 8888,
              "pid": 205,
              "code": "yy",
              "enabled": true,
              "details": [
                  {
                      "locale": "en-US",
                      "organizationId": 206,
                      "name": "余姚",
                      "description": null
                  },
                  {
                      "locale": "zh-CN",
                      "organizationId": 206,
                      "name": "岑迪波",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 215,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650395487,
              "updatedBy": 8888,
              "pid": 205,
              "code": "jb",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 215,
                      "name": "岑丰科",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 215,
                      "name": "江北龙山范市宁波",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 207,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650278551,
              "updatedBy": 8888,
              "pid": 205,
              "code": "zx",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 207,
                      "name": "杜志刚",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 207,
                      "name": "周巷长河天元庵东",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 293,
              "createdAt": 1728017038017,
              "createdBy": 8888,
              "updatedAt": 1728017038017,
              "updatedBy": 8888,
              "pid": 205,
              "code": "sy",
              "enabled": true,
              "details": [
                  {
                      "locale": "en-US",
                      "organizationId": 293,
                      "name": "",
                      "description": null
                  },
                  {
                      "locale": "zh-CN",
                      "organizationId": 293,
                      "name": "宋益",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 209,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650310208,
              "updatedBy": 8888,
              "pid": 205,
              "code": "zh",
              "enabled": true,
              "details": [
                  {
                      "locale": "en-US",
                      "organizationId": 209,
                      "name": "宗汉坎墩",
                      "description": null
                  },
                  {
                      "locale": "zh-CN",
                      "organizationId": 209,
                      "name": "胡旭仪",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 210,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650320851,
              "updatedBy": 8888,
              "pid": 205,
              "code": "hh",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 210,
                      "name": "罗乃军",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 210,
                      "name": "横河",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 294,
              "createdAt": 1728030809874,
              "createdBy": 8888,
              "updatedAt": 1728030809874,
              "updatedBy": 8888,
              "pid": 205,
              "code": "clq",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 294,
                      "name": "岑丽庆",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 294,
                      "name": "",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 212,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650365562,
              "updatedBy": 8888,
              "pid": 205,
              "code": "ky",
              "enabled": true,
              "details": [
                  {
                      "locale": "en-US",
                      "organizationId": 212,
                      "name": "匡堰逍林浒山",
                      "description": null
                  },
                  {
                      "locale": "zh-CN",
                      "organizationId": 212,
                      "name": "岑立江",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 213,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650355377,
              "updatedBy": 8888,
              "pid": 205,
              "code": "ss",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 213,
                      "name": "岑建达",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 213,
                      "name": "胜山崇寿庵东新浦附海",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 287,
              "createdAt": 1726297623917,
              "createdBy": 8888,
              "updatedAt": 1726297623917,
              "updatedBy": 8888,
              "pid": 205,
              "code": "2024091401",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 287,
                      "name": "柴程威",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 287,
                      "name": "",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 208,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650293138,
              "updatedBy": 8888,
              "pid": 205,
              "code": "hzw",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 208,
                      "name": "孙涛",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 208,
                      "name": "杭州湾",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 211,
              "createdAt": 1700704133829,
              "createdBy": 1,
              "updatedAt": 1701650345793,
              "updatedBy": 8888,
              "pid": 205,
              "code": "ghw",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 211,
                      "name": "岑建达1",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 211,
                      "name": "观海卫桥头",
                      "description": null
                  }
              ],
              "children": []
          },
          {
              "id": 298,
              "createdAt": 1729671697718,
              "createdBy": 8888,
              "updatedAt": 1729671697718,
              "updatedBy": 8888,
              "pid": 205,
              "code": "2024102301",
              "enabled": true,
              "details": [
                  {
                      "locale": "zh-CN",
                      "organizationId": 298,
                      "name": "岑仲孟",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "organizationId": 298,
                      "name": "",
                      "description": null
                  }
              ],
              "children": []
          }
      ]
  }
]

const auth_roles = [
  {
      "id": 9,
      "createdAt": 1701320075176,
      "createdBy": 1,
      "updatedAt": 1722303163910,
      "updatedBy": 1,
      "pid": 0,
      "code": "97c3fb84fad946cda5a52418c509ec8b",
      "details": [
          {
              "locale": "en-US",
              "roleId": 9,
              "name": "senior client",
              "description": null
          },
          {
              "locale": "zh-CN",
              "roleId": 9,
              "name": "高级客户",
              "description": null
          }
      ],
      "dataScope": 3,
      "userDataScope": 0,
      "allowSelectDeviceType": "",
      "privilegeLevel": 5,
      "enabled": true,
      "menus": null,
      "isSelfStation": false,
      "children": [
          {
              "id": 4,
              "createdAt": 1,
              "createdBy": 1700704133829,
              "updatedAt": 1717665857717,
              "updatedBy": 8888,
              "pid": 9,
              "code": "ROLE_CUSTOMER",
              "details": [
                  {
                      "locale": "zh-CN",
                      "roleId": 4,
                      "name": "客户",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "roleId": 4,
                      "name": "",
                      "description": null
                  }
              ],
              "dataScope": 3,
              "userDataScope": 0,
              "allowSelectDeviceType": "",
              "privilegeLevel": 5,
              "enabled": true,
              "menus": null,
              "isSelfStation": false,
              "children": []
          }
      ]
  },
  {
      "id": 29,
      "createdAt": 1715157434624,
      "createdBy": 8888,
      "updatedAt": 1718855476693,
      "updatedBy": 8888,
      "pid": 0,
      "code": "a889653760f447b9a591ec4499074e97",
      "details": [
          {
              "locale": "en-US",
              "roleId": 29,
              "name": "",
              "description": null
          },
          {
              "locale": "zh-CN",
              "roleId": 29,
              "name": "开关机功率客户",
              "description": null
          }
      ],
      "dataScope": 3,
      "userDataScope": 0,
      "allowSelectDeviceType": "",
      "privilegeLevel": 4,
      "enabled": true,
      "menus": null,
      "isSelfStation": false,
      "children": [
          {
              "id": 28,
              "createdAt": 1715155158262,
              "createdBy": 8888,
              "updatedAt": 1717665901747,
              "updatedBy": 8888,
              "pid": 29,
              "code": "b18d05f743574a229c57d36486b973c7",
              "details": [
                  {
                      "locale": "zh-CN",
                      "roleId": 28,
                      "name": "功率客户",
                      "description": null
                  },
                  {
                      "locale": "en-US",
                      "roleId": 28,
                      "name": "",
                      "description": null
                  }
              ],
              "dataScope": 3,
              "userDataScope": 0,
              "allowSelectDeviceType": "",
              "privilegeLevel": 4,
              "enabled": true,
              "menus": null,
              "isSelfStation": false,
              "children": []
          }
      ]
  }
]

const onlyCustomer_organization = [
  {
      "id": 204,
      "createdAt": 1700704133829,
      "createdBy": 1,
      "updatedAt": 1700704133829,
      "updatedBy": 1,
      "pid": 0,
      "code": "kh",
      "enabled": true,
      "details": [
          {
              "locale": "en-US",
              "organizationId": 204,
              "name": "Customer",
              "description": null
          },
          {
              "locale": "zh-CN",
              "organizationId": 204,
              "name": "客户",
              "description": null
          }
      ],
      "children": []
  }
]

const onlyCustomer_role = [
  {
      "id": 4,
      "createdAt": 1,
      "createdBy": 1700704133829,
      "updatedAt": 1717665857717,
      "updatedBy": 8888,
      "pid": 9,
      "code": "ROLE_CUSTOMER",
      "details": [
          {
              "locale": "zh-CN",
              "roleId": 4,
              "name": "客户",
              "description": null
          },
          {
              "locale": "en-US",
              "roleId": 4,
              "name": "",
              "description": null
          }
      ],
      "dataScope": 3,
      "userDataScope": 0,
      "allowSelectDeviceType": "",
      "privilegeLevel": 5,
      "enabled": true,
      "menus": null,
      "isSelfStation": false,
      "children": []
  }
]

export default {
    auth_organizations,
    auth_roles,
    onlyCustomer_organization,
    onlyCustomer_role
}